import React, { memo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useModalNotifications, useNotificationUtils } from '../hooks/useNotifications';
import NotificationTable from './NotificationTable';

const ObligatoryModal = memo(() => {
  const {
    notifications,
    showModal,
    hasNotifications,
    isObligatory,
    markAllAsRead,
    closeModal,
    isMarkingAsRead
  } = useModalNotifications();


  const handleClose = () => {
    if (isObligatory && hasNotifications) {
      // Modal obrigatório - não pode fechar
      return;
    }
    closeModal();
  };

  const handleMarkAllAsRead = async () => {
    try {
      await markAllAsRead();
      // Modal fecha automaticamente quando não há mais notificações
    } catch (error) {
      console.error('Erro ao marcar todas como lidas:', error);
    }
  };

  if (!showModal) return null;

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      aria-labelledby="obligatoryModalLabel"
      centered
      size="lg"
      backdrop={isObligatory && hasNotifications ? "static" : true}
      keyboard={!(isObligatory && hasNotifications)}
      dialogClassName="notification-modal-dialog"
      style={{ zIndex: 1050 }}
    >
      <style>{`
        .notification-modal-dialog {
          max-width: 900px;
          width: 90vw;
        }
        
        @media (max-width: 768px) {
          .notification-modal-dialog {
            max-width: 95vw;
            width: 95vw;
            margin: 10px auto;
          }
        }
      `}</style>
      <Modal.Header 
        closeButton={!(isObligatory && hasNotifications)}
        style={{
          background: 'linear-gradient(135deg, #3c8dbc 0%, #2c7aa6 100%)',
          border: 'none',
          color: 'white'
        }}
      >
        <Modal.Title id="obligatoryModalLabel" style={{ 
          fontSize: '18px', 
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center'
        }}>
          <i className="fa fa-bell" style={{ marginRight: '10px', fontSize: '16px' }} />
          {hasNotifications ? (
            <>
              {notifications.length} Notificação{notifications.length > 1 ? 'ões' : ''}
            </>
          ) : (
            'Notificações'
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 0, maxHeight: '70vh', overflowY: 'auto', background: '#f8f9fa' }}>
        {!hasNotifications ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px 20px',
            background: 'white',
            margin: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <i className="fa fa-check-circle" style={{ 
              fontSize: '48px', 
              color: '#28a745',
              marginBottom: '16px'
            }} />
            <h4 style={{ 
              color: '#495057', 
              marginBottom: '8px',
              fontWeight: '600'
            }}>
              Não há notificações pendentes
            </h4>
            <p style={{ 
              color: '#6c757d', 
              margin: 0,
              fontSize: '14px'
            }}>
              Todas as notificações foram lidas.
            </p>
          </div>
        ) : (
          <>
            {isObligatory && (
              <div style={{
                background: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '4px',
                padding: '12px 16px',
                margin: '16px',
                fontSize: '14px',
                color: '#856404'
              }}>
                <i className="fa fa-info-circle" style={{ marginRight: '8px' }} />
                <strong>Atenção:</strong> Estas notificações devem ser lidas antes de continuar.
              </div>
            )}
            <NotificationTable 
              notifications={notifications}
              fromModal={true}
              showActions={true}
            />
          </>
        )}
      </Modal.Body>

      {hasNotifications && (
        <Modal.Footer style={{ 
          background: '#f8f9fa', 
          borderTop: '1px solid #dee2e6',
          padding: '16px 24px'
        }}>
          <Button
            onClick={handleMarkAllAsRead}
            disabled={isMarkingAsRead}
            variant="success"
            style={{
              borderRadius: '4px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: '500',
              marginRight: 'auto'
            }}
          >
            {isMarkingAsRead ? (
              <>
                <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }} />
                Processando...
              </>
            ) : (
              <>
                <i className="fa fa-check-double" style={{ marginRight: '8px' }} />
                Marcar todas como lidas
              </>
            )}
          </Button>
          
          {!isObligatory && (
            <Button 
              onClick={handleClose}
              variant="secondary"
              style={{
                borderRadius: '4px',
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              <i className="fa fa-times" style={{ marginRight: '8px' }} />
              Fechar
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
});

ObligatoryModal.displayName = 'ObligatoryModal';

export default ObligatoryModal;